import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import {Badge, Dropdown} from 'react-bootstrap';
import {useUser} from "../../../hooks/useUser";

const ProfileDropdown = () => {
    const {user} = useUser()
  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
        <Badge pill bg={"primary"} className={"me=2"}>
          <FontAwesomeIcon icon={"user"} /> {user.userName}
        </Badge>
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          {/*<Dropdown.Item className="fw-bold text-warning" href="#!">*/}
          {/*  <FontAwesomeIcon icon="crown" className="me-1" />*/}
          {/*  <span>Go Pro</span>*/}
          {/*</Dropdown.Item>*/}
          {/*<Dropdown.Divider />*/}
          {/*<Dropdown.Item href="#!">Set status</Dropdown.Item>*/}
          {/*<Dropdown.Item as={Link} to="/user/profile">*/}
          {/*  Profile &amp; account*/}
          {/*</Dropdown.Item>*/}
          {/*<Dropdown.Item href="#!">Feedback</Dropdown.Item>*/}
          {/*<Dropdown.Divider />*/}
          {/*<Dropdown.Item as={Link} to="/user/settings">*/}
          {/*  Settings*/}
          {/*</Dropdown.Item>*/}
          <Dropdown.Item as={Link} to="/logout">
            Logout
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
